/**
 *
 */
function initClickListeners() {
  window.o_util.event.delegate(document, "click", ".js_textExpander100__link", function (event) {
    const target = event.target;
    const textExpander = target.closest(".p_textExpander100");
    let customEvent;
    let isOpen;

    if (textExpander) {
      textExpander.classList.toggle("p_expander--decrease");
      isOpen = !!textExpander.classList.contains("p_expander--decrease");
      customEvent = new CustomEvent("textExpanderChange", {
        detail: {
          isOpen,
        },
        bubbles: true,
      });

      this.dispatchEvent(customEvent);
    }
  });
}

window.o_global.eventLoader.onReady(10, initClickListeners);
